import React from 'react'

import ClientDashbordHome from '../Components/ClientDashbord/ClientDashbordHome/ClientDashbordHome'

const ClientPage = () => {
  return (
   <>
   <ClientDashbordHome/>
   </>
  )
}

export default ClientPage
